import { ReactNode } from "react";

interface MainLayoutProps {
  children: ReactNode;
  className?: string;
}

const MainLayout = ({ children, className = "" }: MainLayoutProps) => {
  return (
    <div
      className={`min-h-screen overflow-y-auto flex flex-col pt-[env(safe-area-inset-top)] pb-[80px] px-4 bg-background ${className}`}
      style={{
        WebkitOverflowScrolling: "touch",
        paddingTop: "calc(env(safe-area-inset-top, 0px) + 12px)",
        paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 80px)", // avoid overlap with bottom nav
      }}
    >
      {children}
    </div>
  );
};

export default MainLayout;